import { render, staticRenderFns } from "./FpuiLayoutResizer.vue?vue&type=template&id=63ea98ad&lang=pug&"
import script from "./FpuiLayoutResizer.vue?vue&type=script&lang=js&"
export * from "./FpuiLayoutResizer.vue?vue&type=script&lang=js&"
import style0 from "./FpuiLayoutResizer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports